import { render, staticRenderFns } from "./GoodslistBody.vue?vue&type=template&id=6689c462&scoped=true"
import script from "./GoodslistBody.vue?vue&type=script&lang=js"
export * from "./GoodslistBody.vue?vue&type=script&lang=js"
import style0 from "./GoodslistBody.vue?vue&type=style&index=0&id=6689c462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6689c462",
  null
  
)

export default component.exports